var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopRecord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.114,
    height: 30.122,
    viewBox: "0 0 30.114 30.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15338",
    "data-name": "Group 15338",
    transform: "translate(-1189 -575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accept_1_",
    "data-name": "accept (1)",
    transform: "translate(1186.994 572.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13630",
    "data-name": "Path 13630",
    d: "M17.063,32.192a15.057,15.057,0,1,1,10.652-4.4A15.022,15.022,0,0,1,17.063,32.192Zm0-27.711a12.655,12.655,0,1,0,8.948,3.707A12.569,12.569,0,0,0,17.063,4.48Zm9.8,22.455h0Z",
    fill: "#d93134"
  })), /*#__PURE__*/React.createElement("g", {
    id: "false_1_",
    "data-name": "false (1)",
    transform: "translate(1995.99 -403.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13632",
    "data-name": "Path 13632",
    d: "M-796.99,998.963l10.575-10.593m0,10.593-10.575-10.593",
    fill: "none",
    stroke: "#d93134",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecord);
export default __webpack_public_path__ + "static/media/stopRecord.4995710e3bdce6ab45cbdd87b7509d58.svg";
export { ForwardRef as ReactComponent };